import React from "react";
import parse from "html-react-parser";
import LazyImage from "../LazyImage";
import "./style.css";

const RenderContent = ({ htmlString }) => {
    const renderContent = (htmlString) => {
        if (htmlString) {
            return parse(htmlString, {
                replace: (domNode) => {
                    if (domNode.name === "img") {
                        return <LazyImage src={domNode.attribs.src} alt={domNode.attribs.alt} />;
                    }
                },
            });
        }
        return "";
    };

    return <div className="description">{renderContent(htmlString)}</div>;
};

export default RenderContent;
